import { Content } from "@/ui";
import { getRoute, getRouteObject } from "@/functions/getRoute";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { createTitle } from "@/functions/createTitle";
import sn from "@/snippets";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const route = getRouteObject("ourStoryOurPeople");
  const page = simple_pages_helper.find(route.id, "id");

  if (!page) {
    return { notFound: true };
  }

  return {
    props: {
      meta: { title: createTitle(page.title) },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: page.title, href: route.url },
            ],
          },
        },
        sn.header({ page }),
        ...sn.narrativePanels({
          items: page.narrative_panels.slice(0,5)
        }),
        sn.benefits({
          page,
          className: "pt-5"
        }),
        ...sn.narrativePanels({
          className: "pb-4 pb-md-5",
          items: page.narrative_panels.slice(5,6)
        }),
      ],
    },
  };
}